import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { getTableLang } from "../../Utils/Inits/getTableLang";
import { successToast } from "../../Utils/utils";


export class TaskManager {
    courseId: number;
    table: JQuery;

    constructor(courseId) {
        console.log("INITED")
        this.courseId = courseId;

        this.table = $("#tutor-aufgaben table");
        this.initDataTable();
        this.addListeners();
    }

    initDataTable(){
        const zeilen = ['Aufgaben', 'Aufgabe'];
        this.tableData = this.table.DataTable({
            language: getTableLang({}, zeilen),
            columnDefs: [
                {"orderable": false, "targets": [2,3]}
            ],
            aaSorting: []
        })
    }

    addListeners(){
        const self = this;
        this.table.on("click", ".copy-task", function(){
            const column = $(this).parent();
            const taskId = column.data("aufgabe");

            self.row = column.parent(); // Get row

            const confirmed = confirm("Sicher, dass du diese Aufgabe duplizieren möchtest?");
            if ( confirmed ){

                const url = '/task/' + taskId.toString() + '/duplicate'

                const success = function (data){
                    successToast('Aufgabe wurde dupliziert', 'Erfolg', 8500, true);
                            setTimeout(function(){
                                location.reload();
                            }, 800);
                }

                ajaxRequest(url, success, {}, $(this))
            }
        });
        this.table.on("click", ".delete-task", function(){
            const confirmed = confirm("Sicher, dass du diese Aufgabe löschen möchtest?");
            if ( confirmed ){
                const column = $(this).parent();
                const taskId = column.data("aufgabe");

                self.row = column.parent(); // Get row

                const url = '/task/' + taskId.toString() + '/delete'

                const success = function (data){
                    successToast('Aufgabe gelöscht', 'Erfolg', 7000, true);
                }

                const request = ajaxRequest(url, success, {}, $(this))
                request.done((result) => {
                    self.tableData.row(self.row).remove().draw();
                })

            }
        });
    }
}